import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const Settings = () => {
  return (
    <Box>
      <Typography fontWeight={800} fontSize={24} color="#1e293b" mb={0.5}>Settings</Typography>
      <Typography variant="body2" color="#64748b" mb={3}>Platform configuration</Typography>
      <Paper className="glass-card" sx={{ p: 3, display: "flex", alignItems: "center", gap: 2 }}>
        <SettingsIcon sx={{ color: "#6366f1", fontSize: 28 }} />
        <Typography color="#64748b">Settings panel coming soon</Typography>
      </Paper>
    </Box>
  );
};

export default Settings;
